"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preparse = exports.replaceOr = exports.replaceAnd = exports.replaceNot = void 0;
var tslib_1 = require("tslib");
var compose_1 = tslib_1.__importDefault(require("ramda/src/compose"));
var REPLACE_NOT = /(?:^|\s)!\b(?!:\w)\b/g;
exports.replaceNot = function (source) {
    return source.replace(REPLACE_NOT, ' not ').trim();
};
var REPLACE_LOGICAL_AND = /&&/g;
exports.replaceAnd = function (source) {
    return source.replace(REPLACE_LOGICAL_AND, ' and ').trim();
};
var REPLACE_LOGICAL_OR = /\|\|/g;
exports.replaceOr = function (source) {
    return source.replace(REPLACE_LOGICAL_OR, ' or ').trim();
};
exports.preparse = compose_1.default(exports.replaceAnd, exports.replaceOr, exports.replaceNot);
//# sourceMappingURL=preparse.js.map